import React from 'react';
import { motion } from 'framer-motion';
import { Calendar as CalendarIcon, Clock } from 'lucide-react';
import { Calendar } from '@/components/ui/calendar';
import { isBefore, startOfDay, getDay } from 'date-fns';
import TimeSlotGrid from './TimeSlotGrid';
import BookingSummary from './BookingSummary';

export default function BookingStepDateTime({
  experienceType,
  selectedDate,
  onSelectDate,
  timeSlot,
  onSelectSlot,
  slotRemaining,
  dayHints,
  visibleMonth,
  onMonthChange,
  onWaitlist,
  slots,
  openDays,
}) {
  const openDaysArr = openDays && openDays.length ? openDays : [0, 1, 2, 3, 4, 5, 6];
  return (
    <motion.div key="s2" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }}>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-8">
          {/* Date */}
          <div>
            <p className="text-primary text-xs font-bold tracking-widest mb-4 flex items-center gap-2">
              <CalendarIcon className="w-4 h-4" /> SELECT DATE
            </p>
            <Calendar
              mode="single"
              selected={selectedDate}
              onSelect={(d) => { onSelectDate(d); onSelectSlot(''); }}
              month={visibleMonth}
              onMonthChange={onMonthChange}
              disabled={(date) => isBefore(date, startOfDay(new Date())) || !openDaysArr.includes(getDay(date))}
              modifiers={{
                'avail-open': dayHints?.open || [],
                'avail-limited': dayHints?.limited || [],
                'avail-full': dayHints?.full || [],
              }}
              modifiersClassNames={{
                'avail-open': 'day-avail-open',
                'avail-limited': 'day-avail-limited',
                'avail-full': 'day-avail-full',
              }}
              className="border border-white/10 bg-[#111115] p-4 w-fit"
            />
            {/* Legend */}
            <div className="flex items-center gap-4 mt-3 text-[10px] text-white/30">
              <span className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-[#2EAD6A]" /> Open</span>
              <span className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-[#F0B429]" /> Limited</span>
              <span className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-[#E31D26]" /> Full</span>
            </div>
          </div>

          {/* Time */}
          {selectedDate && (
            <div>
              <p className="text-primary text-xs font-bold tracking-widest mb-4 flex items-center gap-2">
                <Clock className="w-4 h-4" /> SELECT TIME
              </p>
              <TimeSlotGrid
                selectedSlot={timeSlot}
                onSelect={onSelectSlot}
                slotRemaining={slotRemaining}
                selectedDate={selectedDate}
                onWaitlist={onWaitlist}
                slots={slots}
              />
              <p className="text-white/20 text-xs mt-3">
                All sessions are 1 hour in duration.{' '}
                <span className="text-emerald-500/70">X LEFT</span> shows remaining slots —{' '}
                <span className="text-primary">WAITLIST</span> means sold out, click to join the queue.
              </p>
            </div>
          )}
        </div>

        {/* Summary */}
        <div className="lg:col-span-1">
          <BookingSummary experienceType={experienceType} selectedDate={selectedDate} timeSlot={timeSlot} />
        </div>
      </div>
    </motion.div>
  );
}